import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Facet } from '../../models/facet-model';
import { SearchOutputModel } from '../../models/search-output-model';
import { SearchResultsModel } from '../../models/search-results-model';
import { LoaderService } from '../../services/loader.service';
import { QueryStateService } from '../../services/query-state.service';
import { ConstantsService } from '../../services/constants.service';
import { SearchRequestModel } from '../../models/search-request-model';
import { PubSearchService } from '../../services/pub-search.service';
import { MenuItem, MessageService } from 'primeng/api';
import { ReportsService } from '../../services/reports.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ResultColumnsService } from '../../services/result-columns.service';
import { ResultSelectionService } from '../../services/result-selection.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { SortDetails } from '../../models/sort-details-model';
import { MoreDetailsComponent } from '../more-details/more-details.component';
import { ShareViewComponent } from '../share-view/share-view.component';
import { AdamsDocModel } from '../../models/adams-doc-model';
import { environment } from '../../../environments/environment';
import { FolderModel } from '../../models/folder-model';
import { SearchFilter } from '../../models/search-filter-model';
import { FoldersService } from '../../services/folders.service';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';

@Component({
  selector: 'app-home-clean-view',
  templateUrl: './home-clean-view.component.html',
  styleUrls: ['./home-clean-view.component.css']
})
export class HomeCleanViewComponent implements OnInit {

  @Input() query?: string;

  foldersVisible: boolean = true;
  loading = false;
  searchQueryData: SearchRequestModel;
  searchOutput?: SearchOutputModel;
  searchResults: SearchResultsModel[] = []; //Complete list of results retrieved from the search
  hiddenPackageItems: SearchResultsModel[] = []; // the list of items where the package items are hidden.
  viewItems: SearchResultsModel[] = []; // item shown on screen and in the table based on the page and pageSize
  facets?: Facet;
  breadcrumbMenuItems: MenuItem[] | undefined;
  breadcrumbHomeItem: MenuItem | undefined;
  folders: FolderModel[] = [];

  totalCount: number = 0;
  qs?: string | null = '';
  routeLink: string = '';
  editSearchValues: any;
  currentView: string = '';
  pageSize: number = 25;
  first: number = 0;
  showSortReset: boolean = false;
  isFolderSelected = false;

  isDownloading = false;
  downloadOption = 'all';
  showDownloadOptions = false;
  reportType = '';
  isExcelDownload = false;
  progress: number = 0;
  cancelDownload = false;
  downloadFileType = 'CSV';
  selectedProps = [];

  hidePackageContents: boolean = false;
  tableCols: any[] = [];
  defaultTableColumns = ["DocumentTitle", "DateAddedTimestamp", "DateAdded", "DocumentDate"];

  showReportDialog: boolean = false;
  showDownloadDialog: boolean = false;
  showOverlay: boolean = true;
  documentLibraryTitle: string = "Adjudicatory Documents";

  selectedFolder = '';

  constructor(private searchSvc: PubSearchService,
    private queryStateSvc: QueryStateService,
    private msgSvc: MessageService,
    private titleSvc: Title,
    private loaderService: LoaderService,
    private router: Router,
    private reportSvc: ReportsService,
    private folderSvc: FoldersService,
    public dialogService: DialogService,
    public constants: ConstantsService,
    public columnsSvc: ResultColumnsService,
    public selectionSvc: ResultSelectionService
  ) {
    this.titleSvc.setTitle(environment.site_name + ' - Home');

    this.currentView = this.constants.results_view_table;

    this.searchQueryData = {
      q: '', size: this.pageSize, skip: 0, indexId: 'EHD', openProceedings: true, closedProceedings: true
    };
  }

  ngOnInit(): void {
    this.subscribeLoader();

    this.folderSvc.foldersLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.updateFolderTree();
      }
    });

    this.folderSvc.selectedFolder$.subscribe((f) => {
      this.selectionSvc.clearAll();
      this.loadSelectedFolderDocs(f);
      this.selectedFolder = f;
    });

    this.folderSvc.selectedLibrary$.subscribe((l) => {
      // console.log('updated lib...');
      this.selectionSvc.clearAll();
      this.updateFolderTree();
      this.updatedocumentLibraryTitle();
      this.resetBreadCrumbs();
    });

    this.hidePackageContents = false;
    this.initBreadCrumbs();

    this.routeLink = window.location.href;
    this.searchQueryData = this.queryStateSvc.getSearchRequest();

    this.tableCols = this.defaultTableColumns;

    this.initQueryCols();

    this.columnsSvc.parseSelectedCols(this.tableCols);

    this.initReportService();

    // Set a timeout for overlay after 1 seconds
    setTimeout(() => {
      this.showOverlay = false;
    }, 500);
  }

  updateFolderTree(): void {
    const folderStream
      = this.folderSvc.getSelectedLibrary() === this.constants.indexSDM
        ? this.folderSvc.sdmFolders$
        : this.folderSvc.ehdFolders$;

    folderStream
      .subscribe(folders => {
        this.folders = folders;
      });
  }

  resetBreadCrumbs() {
    // Call this when swtiching libraries and initilaizing the BC
    this.breadcrumbMenuItems = [
      { label: 'Select a Folder' },
    ]
    //Home Breadcrumb Item
    this.breadcrumbHomeItem = { icon: 'fas fa-home', routerLink: '/' };
  }

  initBreadCrumbs() {
    this.resetBreadCrumbs();

    // Subscribe to the folder change event in the folder service.  This is wired up once.
    this.folderSvc.selectedFolder$.subscribe((f) => {
      this.updateBreadCrumbs(f);
    });
  }

  initQueryCols() {
    //Adding Properties from Search
    let props = this.queryStateSvc.getSearchFilters();
    if (props && props.length > 0) {
      if (typeof (this.tableCols) == 'string') {
        this.tableCols = JSON.parse(this.tableCols);
      }
      // let mdItems = this.queryStateSvc.getMetadataProps();
      props.forEach((f) => {
        // Don't add if already there....
        if (this.tableCols.indexOf(f.field) == -1) {
          this.tableCols.push(f.field);
        }
      });
    }
  }

  initReportService() {
    this.reportSvc.cancelDownload$.subscribe(cd => { this.cancelDownload = cd; });
    this.reportSvc.isDownloading$.subscribe(d => { this.isDownloading = d; });
    this.reportSvc.downloadFileType$.subscribe(ft => { this.reportType = ft; });
    this.reportSvc.progress$.subscribe(p => { this.progress = p; });
  }

  addPropertySearchCol() {
    //Adding Properties from Search
    let props = this.queryStateSvc.getSearchFilters();
    if (props && props.length > 0) {
      if (typeof (this.tableCols) == 'string') {
        this.tableCols = JSON.parse(this.tableCols);
      }
      let mdItems = this.queryStateSvc.getMetadataProps();
      props.forEach((f) => {
        // Don't add if already there....
        if (this.tableCols.indexOf(f.field) == -1) {
          this.tableCols.push(f.field);
        }
      });
    }
  }

  subscribeLoader() {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }

  loadData() {
    if (this.searchOutput?.results) {
      this.searchResults = this.searchOutput?.results;
      this.hiddenPackageItems = this.filterPackageItems();
    }

    if (this.searchOutput?.count) {
      this.totalCount = this.searchOutput?.count;
      this.selectionSvc.setCount(this.totalCount);
    }

    this.updateView();
  }

  updateView() {
    if (this.hidePackageContents) {
      this.viewItems = this.hiddenPackageItems.slice(0, this.pageSize);
    }
    else {
      this.viewItems = this.searchResults.slice(0, this.pageSize);
    }
  }

  fetchData() {
    let sr = this.queryStateSvc.getUpdatedSearchRequest();
    sr.size = this.searchQueryData.size;
    sr.skip = this.searchQueryData.skip;

    this.selectedFolder = this.ensureRootFolderSlash(this.selectedFolder);

    //Update Search Request to get the data for the selected folder.
    let fldrFilter: SearchFilter = {
      field: 'FoldersFiledIn',
      operator: this.constants.text_operator_equals,
      value: this.selectedFolder
    };
    sr.filters?.push(fldrFilter);

    this.searchSvc.getSearchResultsforFolder(sr).subscribe((data: any) => {
      if (data.results) {
        this.searchResults = data.results;
        this.facets = data.facets;
        this.updateView();
      }
    });
  }

  resetSort() {
    this.queryStateSvc.resetSort();
    this.showSortReset = false;
    this.applyUpdatedSort();
  }

  sortItems(sortDetails: SortDetails) {
    this.queryStateSvc.updateSelectedSort(sortDetails);
    this.showSortReset = true;
    this.applyUpdatedSort();
  }

  applyUpdatedSort() {
    let sr = this.queryStateSvc.getUpdatedSearchRequest();
    this.isFolderSelected = true;

    this.selectedFolder = this.ensureRootFolderSlash(this.selectedFolder);

    //Update Search Request to get the data for the selected folder.
    let fldrFilter: SearchFilter = {
      field: 'FoldersFiledIn',
      operator: this.constants.text_operator_equals,
      value: this.selectedFolder
    };
    sr.filters?.push(fldrFilter);

    sr.indexId = this.folderSvc.getSelectedLibrary();

    sr.skip = 0; // reset the pages to page 1 upon a new sort.
    this.first = 0; //Updated Paging.

    // console.log("Sort Query: " + JSON.stringify(sr));
    this.loading = true;
    this.searchSvc.getSearchResultsforFolder(sr).subscribe((sortedData: any) => {
      if (sortedData.results) {
        this.searchResults = sortedData.results;
        //this.facets = sortedData.facets;
        this.updateView();
        // console.log("updated view.");
      }
      this.loading = false;
    });
  }

  paginate(event: any) {
    this.pageSize = event.rows;
    this.searchQueryData.size = event.rows;

    if (event.first > 100000) {
      this.first = 100000;
      this.searchQueryData.skip = 100000;
    }
    else {
      this.first = event.first;
      this.searchQueryData.skip = event.first;
    }

    this.fetchData();
    this.scrollToTop();
  }

  updateCols(items: any[]) {
    let temp: string[] = [];

    //Convert to String array after the items was updated from the table. 
    items.forEach((i: any) => {
      temp.push(i['field']);
    });

    this.tableCols = temp;
    this.columnsSvc.parseSelectedCols(this.tableCols);
  }

  showDocDetails(item: AdamsDocModel) {
    let itemType = 'Document';
    if (item.IsPackage == 'Yes') {
      itemType = 'Package';
    }

    const dialogRef = this.dialogService.open(MoreDetailsComponent, {
      data: item,
      closable: true,
      header: itemType + ' Item Properties',
      width: '75vw',
      contentStyle: { "max-height": "500px", "overflow": "auto" },
      baseZIndex: 10000
    });
  }

  showShareDialog(doc: AdamsDocModel) {
    const dialogRef = this.dialogService.open(ShareViewComponent, {
      data: doc,
      header: doc.AccessionNumber + ' - ' + doc.DocumentTitle,
      width: '50vw',
      contentStyle: { "max-height": "500px", "overflow": "auto" },
      baseZIndex: 10000
    });
  }

  loadSelectedFolderDocs(selectedFolder: string) {
    let sr = this.queryStateSvc.getUpdatedSearchRequest();
    this.isFolderSelected = true;

    selectedFolder = this.ensureRootFolderSlash(selectedFolder);

    //Update Search Request to get the data for the selected folder.
    let fldrFilter: SearchFilter = {
      field: 'FoldersFiledIn',
      operator: this.constants.text_operator_equals,
      value: selectedFolder
    };
    sr.filters?.push(fldrFilter);

    sr.indexId = this.folderSvc.getSelectedLibrary();

    sr.skip = 0; // reset the page number for paging.
    this.first = 0;

    this.searchSvc.getSearchResultsforFolder(sr).subscribe((r: any) => {
      if (r.results) {
        this.searchOutput = r;
        
        this.hidePackageContents = false;
        this.loadData();
      }
      else {
        this.msgSvc.add({ key: 'facetadded', severity: 'danger', summary: 'No new results to update' })
      }
    });
  }

  ensureRootFolderSlash(str: string) {
    return this.folderSvc.ensureRootFolderSlash(str);
  }

  updateBreadCrumbs(path: string): void {
    if (path) {
      const pathParts = path.split('/');

      this.breadcrumbMenuItems = pathParts.map((folder, index) => ({
        label: folder,
        command: () => this.onBreadcrumbClicked(pathParts.slice(0, index + 1).join('/'))
      }));
    }
  }

  updatedocumentLibraryTitle() {
    this.documentLibraryTitle = this.folderSvc.getSelectedLibrary();
  }

  onBreadcrumbClicked(path: string): void {
    this.folderSvc.setSelectedFolder(path);
  }

  toggleView(newView: string) {
    this.currentView = newView;
  }

  toggleFacets(visible: boolean) {
    this.foldersVisible = visible;
  }
  showCreateReport() {
    this.showReportDialog = true;
  }

  hideReports() {
    this.showReportDialog = false;
  }

  showDownloadDocs() {
    this.showDownloadDialog = true;
  }
  hideDownloadDocs() {
    this.showDownloadDialog = false;
  }

  // Reports Download
  downloadSelected(options: any) {
    this.reportSvc.setFileType(options['fileType']);
    this.reportSvc.downloadOption = options['downloadType'];
    this.reportSvc.selectedProps = options['props'];
    this.reportSvc.setTotalCount(this.totalCount);

    this.showReportDialog = false;
    this.reportSvc.startDownload();
  }

  executeCancelDownload() {
    this.reportSvc.setCancelDownload(true);
  }

  scrollToTop() {
    const tableElement = document.querySelector('#results-top');
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: 'auto' });
    }
  }

  toggleFolderView() {
    this.foldersVisible = !this.foldersVisible;
  }

  togglePackageContents(event: ToggleSwitchChangeEvent) {
    let isChecked = event.checked;
    // use the current view items and filter out any package items that match packages in the same folder.
    this.hidePackageContents = isChecked;
    this.updateView();
  }

  filterPackageItems(): SearchResultsModel[] {

    //Create list of packages in the results 
    const listOfPackages = this.searchResults
      .filter(item => item.document.IsPackage === "Yes")
      .map(item => item.document.AccessionNumber);

    const filteredResults = this.searchResults
      .filter(item => {
        const packagesFiledIn = item.document?.PackagesFiledIn || [];
        return !packagesFiledIn.some(pkg => listOfPackages.includes(pkg));
      });

    return filteredResults;
  }

}
